import React, { useRef, useState } from "react"
import { Link } from "react-router-dom";
// reactstrap components
import {
    Card,
    CardHeader,
    CardBody,
    Container,
    Row,
    Col,
    Button,
    Media
} from "reactstrap";
// core components
import MessageBox from "../../../components/ui/MessageBox";
import Header from "../../../components/headers/Header";
import LoadingIndicator from "../../../components/ui/LoadingIndicator";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";
import { Upload } from "antd";
import "antd/dist/antd.css";
const { Dragger } = Upload;
import "../../../assets/scss/screens/admin/unit/fields/types/uploadImage.scss";
import ProductEditService from "../../../services/screens/admin/product/EditService";
import * as Helper from "../../../utils/Helper";
import { Actions, reducer, INITIAL_STATE, ActionTypes } from "../../../redux/screens/admin/product/EditRedux";
import AuthorizedScreen from "../../../components/base/AuthorizedScreen";
import { NavigationService } from "../../../navigation";
import UIDs from "../../../UIDs";

const uid = UIDs.screens.admin.product.edit;

class EditScreen extends AuthorizedScreen {
    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: { done: null, error: this._handleAsyncActionError },
            [ActionTypes.SAVE_PRODUCT_ASYNC]: { done: this._handleSaveProductAsyncDone, error: this._handleAsyncActionError }
        };
    }

    localVars = {
        navParams: {}
    };

    constructor(props) {
        super(props);

        this.localVars.navParams = NavigationService.getNavParams(props);
    }

    componentDidMount() {
        super.componentDidMount();

        const { id } = this.localVars.navParams;
        if (id)
            this.props.loadScreenViewAsync(id);
        else
            this.props.createProduct();
    }

    render() {
        const { product } = this.props.localState;

        return (
            <>
                <Header />
                <Container className="mt--7" fluid>
                    <Row>
                        <div className="col">
                            {!product || this.isActionExecuting(ActionTypes.LOAD_SCREEN_VIEW_ASYNC)
                                ? <LoadingIndicator />
                                : <EditForm
                                    {...this.props}
                                    product={product}
                                    onSave={this._handleSaveProduct}
                                    isDisabled={this.isActionExecuting(ActionTypes.SAVE_PRODUCT_ASYNC)}
                                />
                            }
                        </div>
                    </Row>
                </Container>
            </>
        );
    }

    _handleSaveProduct = (data) => {
        confirmAlert({
            title: this.props.t("confirmToSave"),
            message: this.props.t("sureToDo"),
            buttons: [
                {
                    label: this.props.t("yes"),
                    onClick: () => {
                        data = { ...data, partnerId: (this.props.partner ? this.props.partner.id : null) }
                        this.props.saveProductAsync(data);
                    }
                },
                {
                    label: this.props.t("no")
                }
            ]
        });
    }

    _handleSaveProductAsyncDone = () => {
        NavigationService.navigateToPageByUID(this, UIDs.screens.admin.product.list, null);
    }

    _handleAsyncActionError = (action) => {
        this.displayError(action.error);
    }
}

function EditForm(props) {
    const { product } = props;
    const { id, title, description, productCover: cover } = product;
    const { register, handleSubmit, errors, setValue } = useForm();
    const submitRef = useRef();

    // store all uploaded imagePath
    const [state_imagePath, setstate_imagePath] = useState(cover||"");

    // represent the image uploading button status
    const [state_imageLoading, setstate_imageLoading] = useState("");

    //粘贴图显示样式
    const [state_pastdivStyle, setstate_pastdivStyle] = useState("upLoadImage");

    const uploadImageProps = {
        name: "fileData",
        multiple: false,
        showUploadList: false, // set to only upload one file
        customRequest: info => {
            startUpload(info.file, "1", uploadImageSuccessCallback);
        },
        beforeUpload: file => {
            const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
            if (!isJpgOrPng) {
                MessageBox.danger({ text: props.t("uploadImageFormatLimited"), duration: 5000 });
                return false;
            }
            const isLt5M = file.size / 1024 / 1024 < 5;
            if (!isLt5M) {
                MessageBox.danger({ text: props.t("uploadImageSizeLimited", { fileSize: 5 }), duration: 5000 });
                return false;
            }
            return isJpgOrPng && isLt5M;
        }
    };

    const startUpload = (file, setStateVal, uploadSuccessCallback) => {
        setstate_imageLoading(setStateVal);
        ProductEditService.upload(
            file,
            response => {
                setstate_imageLoading("");
                uploadSuccessCallback(response);
            },
            error => {
                setstate_imageLoading("");
                MessageBox.danger({ text: error.message, duration: 5000 });
            }
        );
    };

    const uploadImageSuccessCallback = (data) => {
        const { virtualPath } = data;
        setstate_imagePath(virtualPath);
        setValue("cover", virtualPath);
    };

    const removeImage = (index) => {
        setstate_imagePath("");
        setValue("cover", "");
    };

    const upPastePic = (event) =>{
        var getFile = getPastePic(event);
        if(getFile){
            startUpload(getFile, "2", uploadImageSuccessCallback);
        }
    }

    const changePastStyle = (kind) =>{
        if (kind==="click") {
            setstate_pastdivStyle("upLoadImage choiceDiv");
        } else {
            setstate_pastdivStyle("upLoadImage");
        }
    }

    return (
        <Card className="shadow">
            <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                    <Col xs="8">
                        <h3 className="mb-0">{props.t("product")}</h3>
                    </Col>
                    <Col className="text-right" xs="4">
                        <Button
                            color="info"
                            onClick={() => submitRef.current.click()}
                            disabled={props.isDisabled}
                            size="sm">
                            {props.t("save")}
                        </Button>&nbsp;
                        <Button
                            color="default"
                            tag={Link}
                            to={NavigationService.getPathNameByUID(UIDs.screens.admin.product.list)}
                            disabled={props.isDisabled}
                            size="sm">
                            {props.t("cancel")}
                        </Button>
                    </Col>
                </Row>
            </CardHeader>
            <CardBody>
                <form onSubmit={handleSubmit(props.onSave)}>
                    <input name="id" hidden type="text" className="form-control" defaultValue={id} ref={register} />
                    <div className="pl-lg-4">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("cover")}</label>
                                </div>
                            </div>
                        </div>
                        <div className="row uploadImageDiv">
                            <div className="col-lg-12">
                                <div className="form-group" style={{float:"left",marginRight:"20px"}}>
                                    <Dragger {...uploadImageProps}>
                                        <div style={{textAlign:"center",marginTop:"-10px",marginBottom:"-10px",width:"300px",height:"62px"}}>
                                        {
                                            state_imageLoading === "1" ? <span><i className="fa fa-spinner fa-pulse" style={{fontSize:"50px", marginTop:"5px"}}></i></span>
                                            : <div>
                                                <i className="fa fa-inbox" style={{fontSize:"30px", color:"#11cdef"}}></i>
                                                <div style={{fontSize:"16px",marginTop:"5px",paddingLeft:"5px",paddingRight:"5px"}}>{props.t("uploadTitle")}</div>
                                            </div>
                                        }
                                        </div>
                                    </Dragger>
                                </div>
                                <div style={{float:"left", marginRight:"20px",paddingTop:"30px"}}>
                                    {props.t("or")}
                                </div>
                                <div className="form-group" style={{float:"left", marginRight:"20px"}} >
                                <div className={state_pastdivStyle} tabIndex="-1"
                                    onFocus={(e) => { changePastStyle("click") }}
                                    onBlur={(e) => { changePastStyle("outClick") }}
                                    onPaste={(e) => { upPastePic(e) }} >
                                        {
                                            state_imageLoading === "2" ? <span><i className="fa fa-spinner fa-pulse" style={{fontSize:"50px", marginTop:"5px"}}></i></span>
                                            : <div style={{marginTop:"1px"}}>
                                                <i className="fa fa-paste" style={{fontSize:"30px", color:"#2dce89"}}></i>
                                                <div style={{fontSize:"16px",marginTop:"5px"}}>{props.t("pasteTitle")}</div>
                                            </div>
                                        }
                                </div>
                                </div>
                            </div>
                            {state_imagePath !== "" ?
                                <div style={{marginLeft:"13px",marginTop:"-5px"}}>
                                    <div className="imgList">
                                        <div style={{float:"left", cursor:"pointer"}}>
                                            <i className="fa fa-paperclip" aria-hidden="true" style={{marginRight:"5px"}}></i>
                                        </div>
                                        <a style={{float:"left"}} rel="noopener noreferrer nofollow" target="_blank" href={Helper.convertToFileServerPath(state_imagePath)}>
                                            {state_imagePath.substring(state_imagePath.lastIndexOf("/") +1 )}
                                        </a>
                                        <div style={{float:"right", cursor:"pointer"}} onClick={(e) => {removeImage()}}>
                                            <i className="fa fa-times" aria-hidden="true" style={{marginLeft:"10px", padding: "0px 10px"}}></i>
                                        </div>
                                    </div>
                                </div>
                            : null}
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    {state_imagePath !== "" ?
                                        <Media>
                                            <img src={Helper.convertToFileServerPath(state_imagePath)} alt="..." style={{ width: "200px", height: "180px" }} />
                                        </Media>
                                        : null}
                                    <input name={"cover"} defaultValue={cover} hidden ref={register}  readOnly type="text" className="form-control-alternative form-control" />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("title")}</label>
                                    <input name="title" type="text" className="form-control-alternative form-control" defaultValue={title} maxLength={100}
                                        ref={register({ required: true })} />
                                    {errors.title && <span className="text-danger">{props.t("fieldIsRequired")}</span>}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("description")}</label>
                                    <textarea name="description" rows="4" className="form-control-alternative form-control" defaultValue={description}
                                        ref={register} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <input ref={submitRef} type="submit" hidden />
                </form>
            </CardBody>
        </Card>
    );
}

function getPastePic(event){
    var items = (event.clipboardData && event.clipboardData.items) || [];
    var file = null;
    if (items && items.length) {
        for (var i = 0; i < items.length; i++) {
            if (items[i].type.indexOf("image") !== -1) {
                file = items[i].getAsFile();
                break;
            }
        }
    }

    return file;
}

const mapStateToProps = state => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId,
        partner: state.session.partner
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadScreenViewAsync: id => dispatch(Actions.loadScreenViewAsync(id)),
        saveProductAsync: vo => dispatch(Actions.saveProductAsync(vo)),
        createProduct: () => dispatch(Actions.createProduct())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(uid)(EditScreen));
